import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { FloatButton, Layout } from 'antd';

import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import Breadcrumbs from 'components/@extended/Breadcrumbs';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

const { Content } = Layout;

export default function DashboardLayout() {
  const { menuMasterLoading } = useGetMenuMaster();

  useEffect(() => {
    const handler = () => handlerDrawerOpen(window.innerWidth >= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  if (menuMasterLoading) return null;

  return (
    <Layout className="h-screen lg:overflow-hidden">
      <Drawer />
      <Layout className="flex flex-col h-screen">
        <Header />
        <Content id="dashboard-content" className="mt-16 px-2 lg:px-4 py-4 overflow-y-auto overflow-x-hidden flex flex-col bg-[#80c21e0d]">
          <Breadcrumbs />
          <div className="flex-1 ">
            <Outlet />
          </div>
          <Footer className="mt-auto text-center">© 2026 OYN Admin Panel. All rights reserved.</Footer>
          <FloatButton.BackTop
            className="dashboard-back-top"
            target={() => document.getElementById('dashboard-content')}
            tooltip="Back to top"
          />
        </Content>
      </Layout>
    </Layout>
  );
}
